<template>
  <div class="active-skeleton" v-for="i in count" :key="'active-skeleton-' + i">
    <div class="active-skeleton__icon"></div>
    <div class="active-skeleton__info">
      <div class="active-skeleton__row">
        <div class="active-skeleton__text active-skeleton__text--lg"></div>
        <div class="active-skeleton__text active-skeleton__text--lg"></div>
      </div>
      <div class="active-skeleton__row active-skeleton__row--end">
        <div class="active-skeleton__text active-skeleton__text--lg"></div>
        <div class="active-skeleton__text active-skeleton__text--sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivesSkeleton",
  props: {
    count: {
      type: Number,
      default: 5,
    },
  },
}
</script>

<style scoped>
.active-skeleton {
  background-color: var(--second-color);
  border-radius: 14px;
  display: flex;
  align-items: center;
  padding: 10px;
  gap: 10px;
  pointer-events: none;
}

.active-skeleton__icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
  background: linear-gradient(
    90deg,
    rgba(127, 127, 127, 0.08) 25%,
    rgba(127, 127, 127, 0.18) 50%,
    rgba(127, 127, 127, 0.08) 75%
  );
  background-size: 200% 100%;
  animation: active-skeleton-shimmer 1.5s infinite;
}

.active-skeleton__info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.active-skeleton__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.active-skeleton__row--end {
  align-items: flex-end;
}

.active-skeleton__text {
  background: linear-gradient(
    90deg,
    rgba(127, 127, 127, 0.08) 25%,
    rgba(127, 127, 127, 0.18) 50%,
    rgba(127, 127, 127, 0.08) 75%
  );
  background-size: 200% 100%;
  animation: active-skeleton-shimmer 1.5s infinite;
  border-radius: 4px;
}

.active-skeleton__text--lg {
  width: 80px;
  height: 17px;
}

.active-skeleton__text--sm {
  width: 60px;
  height: 14px;
}

@keyframes active-skeleton-shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
